<template>
    <modal @close="$emit('close');" :open="modalOpen">
        <template #default>
            <p>Please verify you are a human. Select the <i :class="selectShapeCss"></i> shape from the list below:</p>
            
            <div class="d-flex flex-wrap">
                <ui-button v-for="(option, index) in options" :key="`verify-human-${index}`" :color="buttonColor(index)" @click="() => selectShape(index)" class="me-3 mb-3">
                    <i :class="buttonCssClass(option)"></i>
                </ui-button>
            </div>

            <p class="small text-muted">
                {{ selected.length }} out of {{ numberOfShape }} selected.
            </p>
        </template>
        <template #buttons>
            <ui-button block="sm" @click="verifyUser">
                Submit
            </ui-button>
        </template>
        
    </modal>
</template>

<script type="text/javascript">
    import CommonComponents from '@/components/Common.vue';
    
    import Utilities from '@/classes/Utilities.js';
    import { UseUIStore } from '@/store/UI.js';

    export default {

        components: {
            ...CommonComponents,
        },

        setup() {
            return {
                uiStore: UseUIStore(),
            };
        },

        data() {
            return {
                allShapes: {
                    star: 'fas fa-star',
                    stamp: 'fas fa-stamp',
                    baby: 'fas fa-baby-carriage',
                    ball: 'fas fa-volleyball-ball',
                    truck: 'fas fa-truck-pickup',
                    mask: 'fas fa-theater-masks',
                    printer: 'fas fa-print',
                    pizza: 'fas fa-pizza-slice',
                    paw: 'fas fa-paw',
                    mitten: 'fas fa-mitten',
                    hippo: 'fas fa-hippo',
                    chess: 'fas fa-chess-pawn',
                    cat: 'fas fa-cat',
                },
                options: [],
                selected: [],
                challengeShape: null,

                modalOpen: true,
                numberOfShape: 0,
            };
        },

        created() {
            let shapeKeys = Object.keys(this.allShapes);
            this.challengeShape = shapeKeys[Utilities.random(0, shapeKeys.length - 1)];

            let num = Utilities.random(1, 3);
            let opts = [];
            for (let i=0; i<num; i++) {
                opts.push({
                    shape: this.challengeShape,
                    sort: Utilities.random(0, 10000),
                });
            }

            for (let i=0; i<(20 - num); i++) {
                let shape = Utilities.random(0, shapeKeys.length - 1);
                opts.push({
                    shape: shapeKeys[shape],
                    sort: Utilities.random(0, 10000),
                });
            }

            opts.sort(function(a, b) {
                return a.sort - b.sort;
            });

            for (let i=0; i<opts.length; i++) {
                if (opts[i].shape == this.challengeShape) {
                    this.numberOfShape++;
                }
                this.options.push(opts[i].shape);
            }
        },

        emits: ['close', 'verify'],

        computed: {
            selectShapeCss() {
                return this.allShapes[this.challengeShape];
            }
        },

        methods: {
            buttonColor(index) {
                if (this.selected.indexOf(index) != -1) {
                    return 'primary';
                }
                return 'none';
            },

            buttonCssClass(option) {
                return this.allShapes[option];
            },

            selectShape(index) {
                let selectedIndex = this.selected.indexOf(index);
                if (selectedIndex != -1) {
                    this.selected.splice(selectedIndex, 1);
                }
                else {
                    this.selected.push(index);
                }
            },

            verifyUser() {
                let allChecked = true;
                for (let i=0; i<this.options.length; i++) {
                    let selected = (this.selected.indexOf(i) != -1);

                    if (this.options[i] == this.challengeShape) {
                        if (!selected) {
                            allChecked = false;
                            break;
                        }
                    }
                    else {
                        if (selected) {
                            allChecked = false;
                            break;
                        }
                    }
                }

                if (!allChecked) {
                    this.uiStore.toast({
                        error: true,
                        title: 'Error',
                        message: 'Please select the correct shape',
                    });
                    return;
                }

                this.modalOpen = false;
                this.$emit('verify');
            },
        },
    };

</script>
